<template lang="pug">
  .section.pb-3
    span.body-2.text-uppercase.grey--text.text--darken-2 {{ title }}
    v-divider.ml-2
</template>

<script>
  export default {
    props: {

      /**
       *
       */
      title: {
        type: String,
        default: "primary",
      },
    },
  }
</script>